import { render, staticRenderFns } from "./DetailPembelian.vue?vue&type=template&id=358a2d36&"
import script from "./DetailPembelian.vue?vue&type=script&lang=js&"
export * from "./DetailPembelian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports